<script>
import lang from "@/directives/lang";

export default {
  name: "DictsysExamples",
  directives: {
    lang
  },
  props: {
    examples: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div class="indentation-container">
    <div v-for="(example, index) in examples" :key="index">
      <div v-if="example.translation" v-lang:source class="d-inline-block">
        <span v-lang:source class="article-content__text">{{ example.translation }}</span
        ><span
          class="article-content__translation-separator article-content__translation-separator--small"
          >&raquo;</span
        >
      </div>
      <span v-lang:target class="article-content__text article-content__text--primary">{{
        example.example
      }}</span>
    </div>
  </div>
</template>
